export const ERROR_TITLES = {
  styles: {
    fetch: 'Unable to load website styles',
    update: 'Unable to update website styles',
  },
};

export const SUCCESS_MESSAGES = {
  styles: {
    update: 'Website styles updated.',
  },
};
